// Reset.
export const RESET = 'unauthorizedState/RESET';

// Ustaw wybrany formularz.
export const SET_SELECTED_FORM = 'unauthorizedState/SET_SELECTED_FORM';
export const SET_FORM_MESSAGE = 'unauthorizedState/SET_FORM_MESSAGE';
